import type { Theme } from '@mui/material/styles'

const styles = {
  root: (theme: Theme) => ({
    '&.hidden': {
      display: 'none',
    },
    overflow: 'auto',
    width: '100%',
    position: 'fixed',
    zIndex: 2,
    left: 0,
    top: 0,
    height: 'calc(100% - var(--payper-bar-height))',
    '--modal-bckg-color': theme.palette.neutral.white,
    backgroundColor: 'var(--modal-bckg-color)',

    '& #p-modal-close-button': {
      backgroundColor: 'var(--modal-bckg-color)',
      position: 'sticky',
      top: 0,
      zIndex: 2,
      '& > div': {
        alignSelf: 'flex-end',
        position: 'absolute',
        zIndex: 3,
        top: (theme: Theme) => ({
          xs: theme.spacing(1),
          md: theme.spacing(1.25),
        }),
        right: (theme: Theme) => ({
          xs: theme.spacing(1),
          md: theme.spacing(2),
        }),
        '& .MuiIconButton-root': {
          p: 0.5,
          fontSize: (theme: Theme) => theme.spacing(1.5),
          '&:hover': {
            borderRadius: '50%',
          },
        },
      },
    },
  }),
  wrapper: (theme: Theme) => ({
    position: 'relative',
    zIndex: 1,

    display: 'grid',
    gridTemplateColumns: '1fr var(--main-layout-width) 1fr',

    '& > *': {
      gridColumn: 2,
    },

    '& .full-bleed': {
      width: '100%',
      gridColumn: '1 / 4',
      borderRadius: 0,
    },

    '& .mobile-full-bleed': {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        gridColumn: '1 / 4',
        borderRadius: 0,
      },
    },
  }),
  fixed: {
    backgroundColor: 'var(--modal-bckg-color)',
    position: 'sticky',
    top: 0,
    zIndex: 2,

    // NOTE: we set the inline-padding instead of the inline-margin
    // for avoiding the visibility of the ArticleCard's box-shadow on scrolling-down
    width: '100%',
    px: 'calc(calc(100% - var(--main-layout-width)) / 2)',

    display: 'flex',
    flexDirection: 'column',
    pt: {
      xs: 2.5,
      md: 4,
    },
    pb: { xs: 1, md: 1.5 },
  },
  content: {
    pb: { xs: 2, md: 4 },
  },
  lineClamp: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
}

export default styles
